export default __webpack_public_path__ + "static/media/upload.4c067911.svg";